import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

export function Kbd(kbdProps: ComponentProps<'kbd'>) {
  const { className, ...props } = kbdProps;
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "bg-muted text-muted-foreground in-data-[slot=tooltip-content]:bg-background/20 in-data-[slot=tooltip-content]:text-background dark:in-data-[slot=tooltip-content]:bg-background/10 h-5 w-fit min-w-5 gap-1 rounded-sm px-1 font-sans text-xs font-medium [&_svg:not([class*='size-'])]:size-3 pointer-events-none inline-flex items-center justify-center select-none",
        className
      )}
      {...props}
    />
  );
}

export function KbdGroup(kbdGroupProps: ComponentProps<'div'>) {
  const { className, ...props } = kbdGroupProps;
  return <kbd data-slot="kbd-group" className={cn('gap-1 inline-flex items-center', className)} {...props} />;
}
